import React from 'react';
import { Button } from '@material-ui/core';
import { EmptyState } from '@backstage/core-components';

const ServiceNotFoundError = () => /* @__PURE__ */ React.createElement(
  EmptyState,
  {
    missing: "data",
    title: "PagerDuty Service Not Found",
    description: "A service could not be found within PagerDuty based on the provided service id. Please verify your configuration.",
    action: /* @__PURE__ */ React.createElement(
      Button,
      {
        color: "primary",
        variant: "contained",
        href: "https://pagerduty.github.io/backstage-plugin-docs/getting-started/pagerduty/"
      },
      "Read More"
    )
  }
);

export { ServiceNotFoundError };
//# sourceMappingURL=ServiceNotFoundError.esm.js.map
